<template>
  <el-dialog
    :visible.sync="visible"
    :show-close="true"
    :append-to-body="true"
    width="556px"
    :custom-class="`skin-modal-container  ${zsTjTheme}`"
    @close="handleClose"
  >
    <template #title>
      <div class="modal-title">
        <span>{{ $t("tj.zs.qhbdfz") }}</span>
      </div>
    </template>
    <div class="skin-content">
      <div class="scroll-wrapper">
        <div class="skin-list">
          <div v-for="key in list" :key="key" class="skin-item" @click="handleChooseItem(key)">
            <div :class="['skin-img', { active: choosedSkin && choosedSkin.name.value === styleData[key].name.value }]">
              <img v-if="styleData[key].icon1" :src="styleData[key].icon1.value" alt="" />
              <img v-else-if="styleData[key].icon" :src="styleData[key].icon.value" alt="" />
            </div>
            <span class="skin-name">{{ styleData[key].name.value }}</span>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  props: {
    styleData: {
      type: Object,
      default: () => ({})
    },
    current: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters(["zsTjTheme"]),
    // 计算属性可以根据需要添加
    list() {
      return Object.keys(this.styleData).filter(key => {
        return this.styleData[key].icon.hasValue;
      });
    }
  },
  watch: {
    visible(newVal) {
      if (newVal && this.current.name) {
        let findKey;
        // 在 styleData 中查找当前选择的服装
        for (const key in this.styleData) {
          if (this.styleData[key].name.value === this.current.name.value) {
            findKey = key;
            break;
          }
        }
        if (findKey) {
          this.choosedSkin = JSON.parse(JSON.stringify(this.styleData[findKey]));
        }
      }
    }
  },
  data() {
    return {
      visible: false,
      choosedSkin: undefined
    };
  },
  methods: {
    handleClose() {
      this.visible = false;
      if (!this.choosedSkin) {
        this.$emit("close", undefined);
        return;
      }

      const obj = JSON.parse(JSON.stringify(this.choosedSkin));
      const result = {
        name: obj.name,
        icon: obj.icon,
        icon1: obj.icon1
      };
      if (obj.skill && obj.skill.ability2 && obj.skill.ability2.desc) {
        result.bindData = this.getStringData(obj.skill.ability2.desc.value);
      }

      this.$emit("close", result);
      this.choosedSkin = undefined;
    },
    getStringData(string) {
      if (!string) return [];
      const arr = string.split("；");
      return arr.map(item => {
        const parts = item.split("：");
        return {
          name: parts[0].trim(),
          value: parts[1] ? parts[1].trim() : ""
        };
      });
    },
    handleChooseItem(key) {
      if (this.choosedSkin && this.choosedSkin.name.value === this.styleData[key].name.value) {
        return;
      }
      this.choosedSkin = this.styleData[key];
    }
  }
};
</script>
<style lang="less">
.skin-modal-container {
  padding: 0 18px 18px;
  background: linear-gradient(155deg, #262f3a 0%, #31415e 100%);
  .el-dialog__header {
    display: flex;
    align-items: center;
    height: 58px;
    padding: 0;
    i {
      // color: #fff;
      transition: color 0.3s;
      // &:hover {
      //   color: #b6c6d9;
      // }
    }
    .modal-title {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      font-weight: bold;
      font-size: 16px;
      color: #ffffff;
    }
  }
  .el-dialog__body {
    padding: 0;
    .skin-content {
      width: 100%;
      padding-bottom: 10px;
      .el-scrollbar__wrap {
        width: 100%;
      }
      .scroll-wrapper {
        overflow: auto;
        &::-webkit-scrollbar {
          height: 8px;
        }
        &::-webkit-scrollbar-button {
          display: none;
        }
        &::-webkit-scrollbar-track {
          background-color: transparent;
        }
        &::-webkit-scrollbar-thumb {
          background-color: #dce6ea;
          border-radius: 10px;
        }
        .skin-list {
          display: flex;
          gap: 0 8px;
          .skin-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 80px;
            cursor: pointer;
            .skin-img {
              width: 80px;
              height: 80px;
              background: rgba(0, 0, 0, 0.4);
              border-radius: 4px;
              border: 2px solid transparent;
              transition: border-color 0.3s;
              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
              &.active {
                border-color: #b6c6d9;
              }
            }
            .skin-name {
              margin-top: 5px;
              line-height: 18px;
              font-size: 13px;
              color: #cdcdcd;
            }
          }
        }
      }
    }
  }
}
.skin-modal-container.light {
  background: linear-gradient(180deg, #effcff 0%, #ffffff 100%);
  border-radius: 8px;
  .el-dialog__header {
    .modal-title {
      color: #333;
    }
  }
  .el-dialog__body {
    .skin-content {
      .scroll-wrapper .skin-list {
        .skin-img {
          background: rgba(163, 178, 189, 0.3);
          &.active {
            border-color: #ff6600;
          }
        }
        .skin-name {
          color: #333333;
        }
      }
    }
  }
}
</style>
